import { useParams, useNavigate } from "react-router-dom";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Briefcase, CheckCircle, ArrowRight } from "lucide-react";
import BrandedHeader from "@/components/BrandedHeader";

export default function PostInterviewPage() {
  const { sessionId } = useParams();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <BrandedHeader>
        <div className="flex items-center gap-2">
          <Briefcase className="w-6 h-6 text-primary" />
          <span className="font-display text-lg">Careers@Securado</span>
        </div>
      </BrandedHeader>
      
      <div className="flex-1 flex items-center justify-center px-4">
      <Card className="max-w-md w-full border-border bg-card" data-testid="post-interview-done-card">
        <CardHeader className="text-center p-8">
          <div className="w-16 h-16 rounded-full bg-[hsl(var(--success))]/10 flex items-center justify-center mx-auto mb-4">
            <CheckCircle className="w-8 h-8 text-[hsl(var(--success))]" />
          </div>
          <CardTitle className="text-2xl font-display">Interview Complete</CardTitle>
          <p className="text-muted-foreground mt-2">
            Thank you for completing your interview. Your responses have been recorded and will be reviewed by our hiring team.
          </p>
        </CardHeader>
        <CardContent className="px-8 pb-8 space-y-4">
          <div className="bg-secondary/50 rounded-lg p-4">
            <h4 className="text-sm font-medium mb-2">What happens next?</h4>
            <ul className="text-xs text-muted-foreground space-y-1.5">
              <li>Your assessment report is being generated</li>
              <li>The hiring team will review your evaluation</li>
              <li>You will be contacted with next steps within 5 business days</li>
            </ul>
          </div>
          <Button
            className="w-full btn-press"
            onClick={() => navigate('/jobs')}
            data-testid="post-interview-back-to-jobs-button"
          >
            Back to Positions
            <ArrowRight className="ml-2 w-4 h-4" />
          </Button>
        </CardContent>
      </Card>
      </div>
    </div>
  );
}
